import { OnInit } from "@angular/core";
var DateTimeComponent = /** @class */ (function () {
    function DateTimeComponent() {
    }
    DateTimeComponent.prototype.ngOnInit = function () { };
    return DateTimeComponent;
}());
export { DateTimeComponent };
